import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../core/i18n';
import { LaunchDialogService } from '../../../core/modal';
import { PrincipalConfigurationDirectiveModule } from '../../directives';
import { PipesModule } from '../../pipes/pipes.module';
import { CheckboxModule } from '../checkbox/checkbox.module';
import { cuttingModalLayoutConfig } from '../cutting/cutting-modal/cutting-modal-layout.config';
import { MessageBannerModule } from '../message-banner/message-banner.module';
import { NotificationModule } from '../notification';
import { OrderEntryModule } from '../order-entry/order-entry.module';
import { reelCuttingModalLayoutConfig } from '../reel-cutting/reel-cutting-modal/reel-cutting-modal-layout.config';
import { ResponsiveTableModule } from '../responsive-table/responsive-table.module';
import { CartEntriesTableComponent } from './cart-entries-table.component';

@NgModule({
  imports: [
    CommonModule,
    PipesModule,
    NzIconModule,
    I18nModule,
    ResponsiveTableModule,
    OrderEntryModule,
    CheckboxModule,
    PrincipalConfigurationDirectiveModule,
    MessageBannerModule,
    NotificationModule,
  ],
  declarations: [CartEntriesTableComponent],
  exports: [CartEntriesTableComponent],
})
export class CartEntriesTableModule {
  constructor(private launchDialogService: LaunchDialogService) {
    this.launchDialogService.registerModalLayoutConfig(cuttingModalLayoutConfig);
    this.launchDialogService.registerModalLayoutConfig(reelCuttingModalLayoutConfig);
  }
}
